import React from "react";

const NextMatches = () => {
  const escudosLocales = {
    Quimsa: "/escudos/quimsa.png",
    Boca: "/escudos/boca.png",
    "Gimnasia CR": "https://upload.wikimedia.org/wikipedia/en/thumb/1/10/Club_Gimnasia_y_Esgrima_logo.svg/1280px-Club_Gimnasia_y_Esgrima_logo.svg.png",
  };

  const getEscudo = (rival, escudoRival) => {
    return escudosLocales[rival] || escudoRival;
  };
  // Cronograma Quimsa vs Gimnasia CR
  const partidos = [
    {
      id: 1,
      juego: "J1 | SAB 6",
      rival: "Gimnasia CR",
      escudoRival: "https://www.unocontraunoweb.com/wp-content/uploads/2023/12/Supercopa-de-La-Liga-2023-Quimsa-v-Gimnasia-CR-1-scaled.jpg",
      fecha: "Sábado 6 — Estadio Ciudad",
      local: true,
      resultado: null,
    },
    {
      id: 2,
      juego: "J2 | LUN 8",
      rival: "Gimnasia CR",
      escudoRival: "https://www.unocontraunoweb.com/wp-content/uploads/2023/12/Supercopa-de-La-Liga-2023-Quimsa-v-Gimnasia-CR-1-scaled.jpg",
      fecha: "Lunes 8 — Estadio Ciudad",
      local: true,
      resultado: null,
    },
    {
      id: 3,
      juego: "J3 | JUE 11",
      rival: "Gimnasia CR",
      escudoRival: "https://www.unocontraunoweb.com/wp-content/uploads/2023/12/Supercopa-de-La-Liga-2023-Quimsa-v-Gimnasia-CR-1-scaled.jpg",
      fecha: "Jueves 11 — Est. Socios Fundadores",
      local: false,
      resultado: null,
    },
    {
      id: 4,
      juego: "J4 | SAB 13",
      rival: "Gimnasia CR",
      escudoRival: "https://www.unocontraunoweb.com/wp-content/uploads/2023/12/Supercopa-de-La-Liga-2023-Quimsa-v-Gimnasia-CR-1-scaled.jpg",
      fecha: "Sábado 13 — Est. Socios Fundadores",
      local: false,
      resultado: null,
    },
    {
      id: 5,
      juego: "J5 | MIE 17",
      rival: "Gimnasia CR",
      escudoRival: "https://www.unocontraunoweb.com/wp-content/uploads/2023/12/Supercopa-de-La-Liga-2023-Quimsa-v-Gimnasia-CR-1-scaled.jpg",
      fecha: "Miércoles 17 — Estadio Ciudad (Si es necesario)",
      local: true,
      resultado: null,
    },
    {
      id: 6,
      juego: "J6 | SAB 20",
      rival: "Gimnasia CR",
      escudoRival: "https://www.unocontraunoweb.com/wp-content/uploads/2023/12/Supercopa-de-La-Liga-2023-Quimsa-v-Gimnasia-CR-1-scaled.jpg",
      fecha: "Sábado 20 — Est. Socios Fundadores (Si es necesario)",
      local: false,
      resultado: null,
    },
    {
      id: 7,
      juego: "J7 | MAR 23",
      rival: "Gimnasia CR",
      escudoRival: "https://www.unocontraunoweb.com/wp-content/uploads/2023/12/Supercopa-de-La-Liga-2023-Quimsa-v-Gimnasia-CR-1-scaled.jpg",
      fecha: "Martes 23 — Estadio Ciudad (Si es necesario)",
      local: true,
      resultado: null,
    },
  ];

  return (
    <section className="bg-[#0d2b66] text-white py-8">
      <div className="container mx-auto px-4">
        <p className="text-center text-yellow-300 font-semibold mb-4 text-lg uppercase tracking-wide">
          Cronograma
        </p>

        <h2 className="text-2xl font-bold mb-8 text-center uppercase">
          Quimsa vs Gimnasia CR
        </h2>

        {/* CARDS */}
        <div className="grid md:grid-cols-3 gap-6">
          {partidos.map((partido) => (
            <div
              key={partido.id}
              className="bg-white/10 backdrop-blur-md rounded-2xl p-5 flex flex-col items-center shadow-lg border border-white/10 hover:scale-105 transition duration-300"
            >
              {/* JUEGO */}
              <span className="bg-yellow-400 text-black text-xs font-bold px-3 py-1 rounded-full mb-4 uppercase">
                {partido.juego}
              </span>

              {/* ESCUDOS */}
              <div className="flex justify-between items-center w-full mb-5">
                <div className="flex flex-col items-center">
                  <img
                    src="/escudos/quimsa.png"
                    alt="Quimsa"
                    className="h-14 w-14 object-contain"
                  />
                  <p className="text-sm mt-1 font-semibold">
                    Quimsa
                  </p>
                </div>

                <span className="text-lg font-bold text-yellow-300">
                  VS
                </span>

                <div className="flex flex-col items-center">
                  <img
                    src={getEscudo(partido.rival, partido.escudoRival)}
                    alt={partido.rival}
                    className="h-14 w-14 object-contain"
                  />
                  <p className="text-sm mt-1 font-semibold">
                    {partido.rival}
                  </p>
                </div>
              </div>

              {/* INFO */}
              <p className="text-base font-semibold text-center">
                {partido.fecha}
              </p>

              <p className="text-xs text-yellow-300 italic mt-2 uppercase tracking-wide">
                {partido.local ? "Local" : "Visitante"}
              </p>

              {/* RESULTADO */}
              {partido.resultado && (
                <p className="text-sm text-green-300 font-bold mt-3">
                  Resultado: {partido.resultado}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NextMatches;